import { Component } from "@angular/core";
import { Router } from '@angular/router';

@Component({
    templateUrl: "./layout.component.html",
    styles: []
})
export class LayoutComponent {

    currentPage: any;

    constructor(
        private router: Router
    ){
    }
    
    onActivate(event) {
        window.scrollTo(0, 0);
        if (this.getUrl() == 'home') this.currentPage = 'home';
        if (this.getUrl() == 'corporate-awards') this.currentPage = 'corporateAwards';
        if (this.getUrl() == 'individual-awards') this.currentPage = 'individualAwards';
        if (this.getUrl() == 'partner-with-us') this.currentPage = 'partnerWithUs';
    }

    ngOnInit() {
        $(document).ready(function () {
            $('html, body').scrollTop(0);

            $(window).on('load', function () {
                setTimeout(function () {
                    $('html, body').scrollTop(0);
                }, 0);
            });
        });
    }

    getUrl() {
        var url = this.router.url;
        url = url.substring(url.lastIndexOf('/') + 1);
        return url;
    }

   
}
